import React from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Button } from "@progress/kendo-react-buttons";
import SubmitButton from "./SubmitButton";
import styles from "./Common.module.scss";

export default function UserConfirmationDialog({
  message,
  dataList = [],
  confirmMessage,
  onClose,
  onClickYes,
  onClickNo,
  isLoading = false,
}) {
  return (
    <Dialog
      id="user_confirmation_dialog"
      title="Confirmation"
      width={640}
      onClose={onClose}
    >
      <div className="w-100 d-flex flex-column align-items-center mt-2 p-3 pt-2 pb-4">
        {message && <p className="text-primary align-self-start">{message}</p>}

        {dataList.length > 0 && (
          <div className={styles.list}>
            {dataList.map((item, index) => (
              <div
                key={`${item?.key ?? "item"}-${index}`}
                className={styles.listItem}
              >
                <span className={styles.listKey}>{item?.key}</span>
                <span className={styles.listValue}>{item?.value}</span>
              </div>
            ))}
          </div>
        )}

        {confirmMessage && (
          <p className="mt-3 mb-4 fw-bold">{confirmMessage}</p>
        )}

        <div className="d-flex gap-2 mt-4">
          <Button
            className="common-btn bgBtnSecondary"
            onClick={onClickNo}
            disabled={isLoading}
          >
            No
          </Button>
          <SubmitButton onClick={onClickYes} isLoading={isLoading}>
            Yes
          </SubmitButton>
        </div>
      </div>
    </Dialog>
  );
}
